module.exports = __webpack_public_path__ + "img/logo.95a573b8.jpg";